import Reveal from './Reveal';

export const SectionHeading = ({ eyebrow, title, blurb, dark = false, align = 'left' }) => (
  <div className={align === 'center' ? 'text-center mx-auto max-w-3xl' : 'max-w-3xl'}>
    <Reveal>
      <p
        data-testid="section-eyebrow"
        className={`text-xs font-bold uppercase tracking-[0.28em] ${dark ? 'text-gold-soft' : 'text-gold'}`}
      >
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-4 font-display tracking-tight leading-[1.12] text-3xl sm:text-4xl lg:text-5xl ${
          dark ? 'text-cream' : 'text-ink'
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {blurb && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed ${dark ? 'text-cream/70' : 'text-muted-foreground'}`}>
          {blurb}
        </p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
